import React from "react";
import { Calendar, Image as ImageIcon } from "lucide-react";
import SectionHeader from "../shared/SectionHeader";
import LogoUploadField from "../shared/LogoUploadField";
import { UPLOAD_KEYS } from "../../../contexts/CompanySettingsContext";

/**
 * Convention Defaults Form Section
 * 
 * @param {Object} props Component properties
 * @param {Function} props.register React Hook Form register function
 * @param {string} props.conventionLogoPreview URL or data URL for convention logo preview
 * @param {Function} props.handleConventionLogoChange Handler for convention logo file changes
 * @param {Object} props.uploadProgress Upload progress status object
 * @param {boolean} props.isUploading Whether an upload is in progress
 */
const ConventionDefaultsForm = ({
  register,
  conventionLogoPreview,
  handleConventionLogoChange,
  uploadProgress,
  isUploading,
}) => (
  <div className="card bg-base-100 border border-base-300">
    <div className="card-body p-6">
      <SectionHeader
        icon={<Calendar className="w-6 h-6 text-primary" aria-hidden="true" />}
        title="Convention Defaults"
        description="Set default values for new conventions"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Default Convention Name</span>
            </label>
            <input
              type="text"
              placeholder="Enter default convention name"
              className="input input-bordered w-full"
              {...register("conventionName")}
            />
          </div>

          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Default Convention Description</span>
            </label>
            <textarea
              placeholder="Enter a description for your conventions"
              className="textarea textarea-bordered w-full h-32"
              {...register("conventionDescription")}
            ></textarea>
          </div>
        </div>

        <div className="space-y-4">
          <LogoUploadField
            title="Default Convention Logo"
            description="This logo will be the default for new conventions you create."
            preview={conventionLogoPreview}
            progress={uploadProgress[UPLOAD_KEYS.CONVENTION_LOGO] || 0}
            onChange={handleConventionLogoChange}
            icon={<ImageIcon className="w-5 h-5" aria-hidden="true" />}
            type="convention"
            isUploading={isUploading}
          />
        </div>
      </div>
    </div>
  </div>
);

export default ConventionDefaultsForm; 